import React, { Component } from 'react'

import { FillerDiv } from '../StyledComponents/Fillers'
import SettingsRowSwitch from '../Settings/SettingsRowSwitch'
import SettingsRowSelect from '../Settings/SettingsRowSelect'
import SettingsRowEmpty from '../Settings/SettingsEmptyRow'
import Selection from '../Settings/Selection'
import { SelectionNavigator, SelectionNavigatorBackLink, SelectionNavigatorTitle, SelectionBackImage } from '../StyledComponents/Selection'

const WATERING_DEMAND_TYPE = 'watering_demand'
const wateringDemandOptions = [
    {
        value: 'NOT_SPECIFIED',
        label: 'Egal',
    },
    {
        value: 'LOW',
        label: 'Niedrig',
    },
    {
        value: 'AVERAGE',
        label: 'Mittel',
    },
    {
        value: 'HIGH',
        label: 'Hoch',
    },
]

const LOACTION_TYPE = 'plant_location'
const locationOptions = [
    {
        value: 'NOT_SPECIFIED',
        label: 'Egal',
    },
    {
        value: 'SUN',
        label: 'Sonne',
    },
    {
        value: 'HALF_SHADE',
        label: 'Halbschatten',
    },
    {
        value: 'SHADE',
        label: 'Schatten',
    },
]

const CUTTING_TIME_TYPE = 'cutting_time'
const cuttingTimeOptions = [
    {
        value: 'NOT_SPECIFIED',
        label: 'Egal',
    },
    {
        value: 'SPRING',
        label: 'Frühling',
    },
    {
        value: 'SUMMER',
        label: 'Sommer',
    },
    {
        value: 'AUTUMN',
        label: 'Herbst',
    },
    {
        value: 'WINTER',
        label: 'Winter',
    },
]

class FilterView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectOpened: false,
            selectOptions: [],
            selectTitle: '',
            selectType: null,
        }
        this.openSelection = this.openSelection.bind(this)
        this.closeSelection = this.closeSelection.bind(this)
    }

    openSelection(title, options, type) {
        this.setState({
            selectOpened: true,
            selectOptions: options,
            selectTitle: title,
            selectType: type,
            filtersChanged: false,
        })
    }

    closeSelection(type, newValue, e) {
        if (newValue) {
            switch (type) {
                case WATERING_DEMAND_TYPE:
                    this.props.onFilterChange('waterdemand', newValue)
                    break
                case LOACTION_TYPE:
                    this.props.onFilterChange('location', newValue)
                    break
                case CUTTING_TIME_TYPE:
                    this.props.onFilterChange('cuttingtime', newValue)
                    break
                default:
            }
        }

        this.setState({
            selectOpened: false,
            selectType: null,
            filtersChanged: true,
        })
    }


    render() {
        const {
            selectOpened,
            selectTitle,
            selectType,
            selectOptions,
            filtersChanged,
        } = this.state

        const {
            filters, onClose, onFilterChange, authUser,
        } = this.props

        if (selectOpened) {
            return (
                <Selection
                    closeSelection={this.closeSelection}
                    title={selectTitle}
                    options={selectOptions}
                    type={selectType}
                />
            )
        }

        const favoritesFilter = authUser
            ? (
                <SettingsRowSwitch
                    checked={filters.favorites || false}
                    handleChange={() => onFilterChange('favorites', !filters.favorites)}
                    isFirst
                    title="Nur Favoriten"
                />
            ) : null
        return (
            <FillerDiv>
                <SelectionNavigator>
                    <SelectionNavigatorBackLink onClick={() => onClose(filtersChanged)}>
                        <SelectionBackImage name="angle-left" size="2x" />
                    </SelectionNavigatorBackLink>
                    <SelectionNavigatorTitle>Filter</SelectionNavigatorTitle>
                </SelectionNavigator>
                <SettingsRowEmpty />
                <FillerDiv>
                    <FillerDiv>
                        {favoritesFilter}
                        <SettingsRowSelect
                            title="Wasserbedarf"
                            openSelection={this.openSelection}
                            options={wateringDemandOptions}
                            selectedItem={filters.waterdemand}
                            type={WATERING_DEMAND_TYPE}
                        />
                        <SettingsRowSelect
                            title="Standort"
                            openSelection={this.openSelection}
                            options={locationOptions}
                            selectedItem={filters.location}
                            type={LOACTION_TYPE}
                        />
                        <SettingsRowSelect
                            title="Schnittzeit"
                            openSelection={this.openSelection}
                            options={cuttingTimeOptions}
                            selectedItem={filters.cuttingtime}
                            type={CUTTING_TIME_TYPE}
                        />
                    </FillerDiv>
                </FillerDiv>
                <SettingsRowEmpty />
            </FillerDiv>
        )
    }
}

export default FilterView



// WEBPACK FOOTER //
// ./src/components/Plant/FilterView.js